// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3_0v5","signatureBlock":"Footer_signatureBlock__2YgrD","signature":"Footer_signature__39twL"};